import React, { useState } from "react";
import Header from "../components/header";
import Layout from "../components/layout";
import { Link } from "gatsby";
import * as styles from "./random.module.css";

export default function About() {
  const [rand, setRand] = useState(0);
  const [inputVal, setInputVal] = useState(0);

  const handleSubmit = () => {
    setRand(Math.floor(Math.random() * inputVal));
  };

  const onValueChange = arg => {
    setInputVal(arg.target.value);
  };

  return (
    <Layout>
      <Header headerText="My Journal" />
      <p>Random number generation</p>
      <div className={styles.random}>
        <div>
          <input
            type="number"
            value={inputVal}
            onChange={ev => onValueChange(ev)}
          />
          <button onClick={handleSubmit}>Submit</button>
        </div>
        <div className={styles.tag}>{rand}</div>
      </div>
      <Link to="/scary">Click to get scared</Link>
      <h2>
        Go
        <a href="https://journal-random.netlify.app/admin/"> here </a>
        for Netlify CMS
      </h2>
    </Layout>
  );
}
